import {
  contactsData,
  contactsDataPost,
  contactsDataUpdate,
  contactsDataDelete,
} from "./contactsActions";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ErrorResponse } from "src/types/error-response.type";
import { ContactWithID } from "src/types/request.type";
import { SuccessResponse } from "src/types/success-response.type";






type ContactsState = {
  dataContacts: {
    payload: ContactWithID[] | null;
    payload_update: ContactWithID | null;
    loading: boolean;
    success: boolean;
    error: string | null;
  };
};

const initialState: ContactsState = {
  dataContacts: {
    loading: false,
    success: false,
    payload_update: null,
    payload: [],
    error: "",
  },
};

const contactsSlice = createSlice({
  name: "contacts",
  initialState: initialState,
  reducers: {
    // Обычные редьюсеры
    setContactsState(state, action: PayloadAction<ContactWithID[]>) {
      state.dataContacts.payload = [];
      state.dataContacts.payload = action.payload;
    },

    setContactsUpdateState(state, action: PayloadAction<ContactWithID>) {
      state.dataContacts.payload_update = null;
      state.dataContacts.payload_update = action.payload;
    //  console.log(state.dataContacts.payload_update);
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(contactsData.pending, (state) => {
        state.dataContacts.loading = true;
        state.dataContacts.error = null;
      })
      .addCase(contactsData.fulfilled, (state, action) => {
        state.dataContacts.loading = false;
        contactsSlice.caseReducers.setContactsState(state, action);
      })
      .addCase(contactsData.rejected, (state, action) => {
        state.dataContacts.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataContacts.error = errorText ? errorText : "";
      })

      ////
      .addCase(contactsDataPost.pending, (state) => {
        state.dataContacts.loading = true;
        state.dataContacts.error = "";
      })
      .addCase(contactsDataPost.fulfilled, (state, action) => {
        state.dataContacts.loading = false;
        //clientsSlice.caseReducers.setClientsState(state, action);
      })
      .addCase(contactsDataPost.rejected, (state, action) => {
        state.dataContacts.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataContacts.error = errorText ? errorText : "";
      })

      ////
      .addCase(contactsDataUpdate.pending, (state) => {
        state.dataContacts.loading = true;
        state.dataContacts.error = "";
      })
      .addCase(contactsDataUpdate.fulfilled, (state, action) => {
        state.dataContacts.loading = false;
        contactsSlice.caseReducers.setContactsUpdateState(state, action);
      })
      .addCase(contactsDataUpdate.rejected, (state, action) => {
        state.dataContacts.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataContacts.error = errorText ? errorText : "";
      })

      ////
      .addCase(contactsDataDelete.pending, (state) => {
        state.dataContacts.loading = true;
        state.dataContacts.error = "";
      })
      .addCase(contactsDataDelete.fulfilled, (state, action) => {
        state.dataContacts.loading = false;
        //clientsSlice.caseReducers.setClientsState(state, action);
      })
      .addCase(contactsDataDelete.rejected, (state, action) => {
        state.dataContacts.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataContacts.error = errorText ? errorText : "";
      });
  },
});

const getErrorText = (error: ErrorResponse) => {
 // console.log(error);

  switch (error?.error) {
    case "invalid0":
      return "invalid0";
    case "invalid1":
      return "invalid1";
    default:
      return "";
  }
};

export default contactsSlice.reducer;
